<div class="invoice-address-container">
    <div class="invoice-address-form-section">
        <!--        Billing Info Title-->
        <!-- <h2 *ngIf="showTitle"
            translate="shared.labels.billingInformation"></h2> -->

        <form class="invoice-address-form"
              *ngIf="invoiceAddressInfoFormGroup"
              [formGroup]="invoiceAddressInfoFormGroup"
              fxLayout="column"
              fxLayoutGap="10px">


            <!--      Fatura tipi-->
            <div fxLayout="row"
                 fxLayoutAlign="start start">
                <mat-button-toggle-group class="billing-type"
                                         [value]="isCorporateAddress"
                                         (valueChange)="updateInvoiceAddress($event)"
                                         hideSingleSelectionIndicator>
                    <mat-button-toggle [value]="false">{{'shared.labels.individual'|translate}}</mat-button-toggle>
                    <mat-button-toggle [value]="true">{{'shared.labels.corporate'|translate}}</mat-button-toggle>
                </mat-button-toggle-group>
            </div>


            <!--        Corporate Billing Address Form-->
            <section class="corporate-billing-address-form-section"
                     *ngIf="isCorporateAddress"
                     fxLayout="column">


                <!--         Firm Name-->
                <div class="form-group control-phone" fxFlex.lt-md="100%" fxFlex>
                    <mat-form-field appearance="fill" fxFlex>
                        <mat-label translate="shared.labels.firmName"></mat-label>
                        <input formControlName="companyTitle"
                               type="text"
                               matInput
                               name="companyTitle">
                        <mat-error>
                         <span
                            *ngIf="invoiceAddressInfoFormGroupControls['companyTitle']?.errors?.['required']"
                            translate="shared.validation.errors.firmNameRequired">
                            </span>
                        </mat-error>
                    </mat-form-field>
                </div>


                <!--        TCKN/VKN & TaxOffice-->
                <div class="form-row-group"
                     fxLayout="row"
                     fxLayoutGap="10px"
                     fxLayout.lt-sm="column">

                    <!--        Tax Number-->
                    <div class="form-group control-taxNumber" fxFlex.lt-md="100%" fxFlex>
                        <mat-form-field appearance="fill" fxFlex>
                            <mat-label translate="shared.labels.taxNumber"></mat-label>
                            <input formControlName="taxNo"
                                   type="text"
                                   matInput
                                   name="taxNo">
                            <mat-error>
                              <span
                                *ngIf="invoiceAddressInfoFormGroupControls['taxNo']?.errors"
                                translate="shared.validation.errors.taxNumberRequired">
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!--        Tax Office-->
                    <div class="form-group control-taxOffice" fxFlex.lt-md="100%" fxFlex>
                        <mat-form-field appearance="fill" fxFlex>
                            <mat-label translate="shared.labels.taxOffice"></mat-label>
                            <input formControlName="taxOffice"
                                   type="text"
                                   matInput
                                   name="taxOffice">
                            <mat-error>
                                  <span
                                    *ngIf="invoiceAddressInfoFormGroupControls['taxOffice']?.errors?.['required']"
                                    translate="shared.validation.errors.taxOfficeRequired">
                                    </span>
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>


            </section>

        </form>
    </div>
</div>
